import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Separator } from '../components/ui/separator';
import { ThemeToggle } from '../components/ThemeToggle';
import { useAuth } from '../contexts/AuthContext';
import { User, LogOut, Palette } from 'lucide-react';

export default function Settings() {
  const { user, logout, isStudent, isTeacher } = useAuth();

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight mb-2 font-serif">Settings</h1>
        <p className="text-lg text-muted-foreground">
          Manage your account and preferences
        </p>
      </div>

      {/* User Information */}
      <Card className="mb-6">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <User className="h-5 w-5" aria-hidden="true" />
            Account
          </CardTitle>
          <CardDescription>
            Your account information and credentials
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* Display-only account fields use a description list (WCAG 1.3.1). */}
          <dl className="space-y-4">
            {isStudent && (
              <div>
                <dt className="text-sm font-medium text-muted-foreground">Student Access Code</dt>
                <dd className="mt-1 p-3 bg-accent rounded-lg font-mono font-semibold">{user.accessCode}</dd>
              </div>
            )}
            {isTeacher && (
              <>
                <div>
                  <dt className="text-sm font-medium text-muted-foreground">Name</dt>
                  <dd className="mt-1 p-3 bg-accent rounded-lg font-semibold">{user.name}</dd>
                </div>
                <div>
                  <dt className="text-sm font-medium text-muted-foreground">Email</dt>
                  <dd className="mt-1 p-3 bg-accent rounded-lg">{user.email}</dd>
                </div>
                <div>
                  <dt className="text-sm font-medium text-muted-foreground">Role</dt>
                  <dd className="mt-1 p-3 bg-accent rounded-lg capitalize">{user.role}</dd>
                </div>
              </>
            )}
          </dl>

          <Separator />

          <Button
            variant="destructive"
            className="w-full justify-start"
            onClick={logout}
          >
            <LogOut className="h-4 w-4 mr-2" aria-hidden="true" />
            Log Out
          </Button>
        </CardContent>
      </Card>

      {/* Appearance */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Palette className="h-5 w-5" aria-hidden="true" />
            Appearance
          </CardTitle>
          <CardDescription>
            Customize how Readwell looks on your device
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">Theme</p>
              <p className="text-sm text-muted-foreground">
                Choose light, dark, or system theme
              </p>
            </div>
            <ThemeToggle />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
